import { loadState, saveState, clearState } from './storages';
import Cookies from './cookies';

const DEFAULT_STORAGE_KEY = 'wc';

const storageFactory = (storageType) => {
    let storage = null;
    switch (storageType) {
        case 'session':
            storage = window.sessionStorage;
            break;
        case 'local':
            storage = window.localStorage;
            break;
    }

    if (!storage) {
        return;
    }

    const storageObject = {
        get: (key, storageKey = DEFAULT_STORAGE_KEY) => {
            const state = loadState(storage, storageKey) || {};
            return state[key];
        },
        set: (key, value, storageKey = DEFAULT_STORAGE_KEY) => {
            const state = loadState(storage, storageKey) || {};
            state[key] = value;
            saveState(storage, storageKey, state);
        },
        clear: (key, storageKey = DEFAULT_STORAGE_KEY) => {
            storageObject.set(key, null, storageKey);
        },
        clearAll: (storageKey = DEFAULT_STORAGE_KEY) => {
            clearState(storage, storageKey);
        },
        isPresent: (storageKey = DEFAULT_STORAGE_KEY) => {
            return !!storage.getItem(storageKey);
        }
    };

    return storageObject;
};

const localStorage = new storageFactory('local');
const sessionStorage = new storageFactory('session');

export { localStorage, sessionStorage, Cookies };
